/* ============================================================
   NOBUCK — Landings de producto (Magic Gumb + Espuma Limpiadora)
   Script compartido, cargado con defer para no bloquear el pintado.
   Las variables UPSELL_ID y CURRENT_VARIANT_ID las define cada section
   inline (vienen de Liquid) y se ejecutan antes que este archivo.
   ============================================================ */

function switchSlide(i){var slides=document.querySelectorAll('.gallery-slide');slides.forEach(function(s,j){s.classList.toggle('active',j===i);});document.querySelectorAll('.thumb-item').forEach(function(t,j){t.classList.toggle('active',j===i);});var vid=document.getElementById('galleryVideo');if(vid){var a=slides[i];if(a&&a.contains(vid)){if(!vid.src&&vid.dataset.src){vid.src=vid.dataset.src;}vid.play().catch(function(){});}else{vid.pause();vid.currentTime=0;}}}

(function(){
  var mainGallery = document.querySelector('.gallery-main');
  if(!mainGallery) return;
  var slideCount = document.querySelectorAll('.gallery-slide').length;
  var startX = 0, startY = 0, tracking = false;
  mainGallery.addEventListener('touchstart', function(e){
    if(e.touches.length !== 1) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    tracking = true;
  }, {passive:true});
  mainGallery.addEventListener('touchend', function(e){
    if(!tracking) return;
    tracking = false;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var activeIndex = 0;
    document.querySelectorAll('.gallery-slide').forEach(function(s,i){ if(s.classList.contains('active')) activeIndex = i; });
    var next;
    if(dx < 0){ next = (activeIndex + 1) % slideCount; } else { next = (activeIndex - 1 + slideCount) % slideCount; }
    switchSlide(next);
  }, {passive:true});
})();

function setPack(el,variantId,price,save){document.querySelectorAll('.pack-btn').forEach(function(x){x.classList.remove('active');});el.classList.add('active');document.getElementById('hPrice').textContent='$'+price;CURRENT_VARIANT_ID=variantId;var sv=document.getElementById('hSave');if(save){sv.textContent=save;sv.style.display='inline-block';}else{sv.style.display='none';}}

var upsellSelected=false;
function toggleUpsell(){upsellSelected=!upsellSelected;document.getElementById('upsellWrap').classList.toggle('selected',upsellSelected);document.getElementById('upsellIcon').style.display=upsellSelected?'block':'none';}

var toastTimer=null;
function showToast(msg){
  var t=document.getElementById('mgToast');
  if(!t)return;
  t.textContent=msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer=setTimeout(function(){t.classList.remove('show');},3400);
}

var isProcessing = false;

function addItems(items){
  return fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items})
  }).then(function(res){
    return res.json().then(function(data){
      if(!res.ok){
        var msg=(data && data.description) ? data.description : 'No pudimos agregar el producto. Intenta de nuevo.';
        throw new Error(msg);
      }
      return data;
    });
  });
}

function setButtonLoading(btn, loadingText){
  btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
  btn.textContent = loadingText;
  btn.disabled = true;
}
function resetButton(btn){
  if(btn.dataset.originalText){ btn.textContent = btn.dataset.originalText; }
  btn.disabled = false;
}
function lockBothButtons(activeBtn, loadingText){
  var addBtn = document.getElementById('btnAddCart');
  var buyBtn = document.getElementById('btnBuyNow');
  setButtonLoading(activeBtn, loadingText);
  [addBtn, buyBtn].forEach(function(b){ if(b && b !== activeBtn){ b.disabled = true; } });
}
function unlockBothButtons(){
  resetButton(document.getElementById('btnAddCart'));
  resetButton(document.getElementById('btnBuyNow'));
}

function addMainThenUpsell(){
  return addItems([{quantity:1,id:CURRENT_VARIANT_ID}]).then(function(){
    if(!upsellSelected) return;
    return addItems([{quantity:1,id:UPSELL_ID}]).catch(function(){
      showToast('Agregamos tu producto, pero el complemento se agotó justo ahora.');
    });
  });
}

function handleAddToCart(){
  if(isProcessing) return;
  isProcessing = true;
  lockBothButtons(document.getElementById('btnAddCart'), 'Agregando…');
  addMainThenUpsell().then(function(){
    window.location.href='/cart';
  }).catch(function(err){
    isProcessing = false;
    unlockBothButtons();
    showToast(err.message || 'No pudimos agregar el producto. Intenta de nuevo.');
  });
}

function handleBuyNow(){
  if(isProcessing) return;
  isProcessing = true;
  lockBothButtons(document.getElementById('btnBuyNow'), 'Procesando…');
  addMainThenUpsell().then(function(){
    window.location.href='/checkout';
  }).catch(function(err){
    isProcessing = false;
    unlockBothButtons();
    showToast(err.message || 'No pudimos procesar tu compra. Intenta de nuevo.');
  });
}

function loadAndPlay(vid){
  if(!vid.src&&vid.dataset.src){vid.src=vid.dataset.src;}
  vid.play().catch(function(){});
  var thumb=vid.closest('.video-thumb');
  thumb.classList.add('loaded');
  var idx=thumb.id.replace('vt','');
  var ov=document.getElementById('ro'+idx);
  if(ov)ov.classList.add('hidden');
}
function pauseReel(vid){
  vid.pause();
  var idx=vid.closest('.video-thumb').id.replace('vt','');
  var ov=document.getElementById('ro'+idx);
  if(ov)ov.classList.remove('hidden');
}
function toggleReel(vid){if(vid.paused){loadAndPlay(vid);}else{pauseReel(vid);}}
var reelObs=new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    var vid=e.target.querySelector('.reel-video');
    if(!vid)return;
    if(e.isIntersecting){loadAndPlay(vid);}else{pauseReel(vid);}
  });
},{threshold:0.6});
document.querySelectorAll('.video-thumb').forEach(function(t){reelObs.observe(t);});

(function(){
  var steps = document.querySelectorAll('.vstep-video, .ba-video');
  if(!steps.length) return;
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      if(e.isIntersecting){
        if(!v.src){
          var src = v.dataset.src;
          if(!src && v.dataset.srcMobile){
            src = window.matchMedia('(min-width: 768px)').matches
              ? v.dataset.srcDesktop
              : v.dataset.srcMobile;
          }
          if(src){ v.src = src; }
        }
        v.play().catch(function(){});
      } else {
        v.pause();
      }
    });
  },{threshold:0.25});
  steps.forEach(function(v){ obs.observe(v); });
})();

function toggleFaq(btn){var item=btn.closest('.faq-item');var isOpen=item.classList.contains('open');document.querySelectorAll('.faq-item.open').forEach(function(i){i.classList.remove('open');});if(!isOpen)item.classList.add('open');}

(function(){
  var slides = document.querySelectorAll('#painSlider .pain-slide');
  var dots = document.querySelectorAll('#painDots .pain-dot');
  if (!slides.length) return;
  var idx = 0;
  setInterval(function(){
    if(document.hidden) return;
    slides[idx].classList.remove('active');
    dots[idx].classList.remove('active');
    idx = (idx + 1) % slides.length;
    slides[idx].classList.add('active');
    dots[idx].classList.add('active');
  }, 3000);
})();

(function(){
  var outer = document.getElementById('videosScrollOuter');
  var track = document.getElementById('videosScroll');
  if(!outer || !track) return;
  var paused = false;
  var resumeTimer = null;
  var speed = 0.4;
  var pos = 0;
  var dragging = false;
  var dragStartX = 0;
  var dragStartPos = 0;
  var dragMoved = false;
  var rafId = null;
  var onScreen = false;

  function getMaxScroll(){ return Math.max(0, track.scrollWidth - outer.clientWidth); }
  function setPos(p){
    var max = getMaxScroll();
    if(p < 0) p = 0;
    if(p > max) p = max;
    pos = p;
    track.style.transform = 'translateX(-' + pos + 'px)';
  }
  function scheduleResume(){
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function(){ paused = false; }, 2500);
  }
  function dragStart(x){
    dragging = true;
    dragMoved = false;
    paused = true;
    clearTimeout(resumeTimer);
    dragStartX = x;
    dragStartPos = pos;
  }
  function dragMove(x){
    if(!dragging) return;
    var dx = dragStartX - x;
    if(Math.abs(dx) > 4) dragMoved = true;
    setPos(dragStartPos + dx);
  }
  function dragEnd(){
    if(!dragging) return;
    dragging = false;
    scheduleResume();
  }

  outer.addEventListener('mouseenter', function(){ if(!dragging) paused = true; });
  outer.addEventListener('mouseleave', function(){ if(!dragging) paused = false; });

  outer.addEventListener('pointerdown', function(e){
    dragStart(e.clientX);
    try { outer.setPointerCapture(e.pointerId); } catch(err) {}
  });
  outer.addEventListener('pointermove', function(e){
    if(!dragging) return;
    dragMove(e.clientX);
  });
  outer.addEventListener('pointerup', function(){ dragEnd(); });
  outer.addEventListener('pointercancel', function(){ dragEnd(); });
  outer.addEventListener('pointerleave', function(){ if(dragging) dragEnd(); });

  track.addEventListener('click', function(e){
    if(dragMoved){
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);

  function step(){
    if(!paused && !dragging){
      var maxScroll = getMaxScroll();
      if(maxScroll > 0){
        pos += speed;
        if(pos >= maxScroll){ pos = 0; }
        track.style.transform = 'translateX(-' + pos + 'px)';
      }
    }
    rafId = requestAnimationFrame(step);
  }

  function startLoop(){
    if(rafId === null){ rafId = requestAnimationFrame(step); }
  }
  function stopLoop(){
    if(rafId !== null){ cancelAnimationFrame(rafId); rafId = null; }
  }

  var loopObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      onScreen = e.isIntersecting;
      if(onScreen && !document.hidden){ startLoop(); } else { stopLoop(); }
    });
  },{threshold:0.05});
  loopObs.observe(outer);

  document.addEventListener('visibilitychange', function(){
    if(document.hidden){ stopLoop(); }
    else if(onScreen){ startLoop(); }
  });
})();
